import { Injectable, signal } from '@angular/core'
import { App } from '@capacitor/app'
import { pDefer } from '@naturalcycles/js-lib'
import { QuizId } from '@naturalcycles/shared'
import { Subject } from 'rxjs'
import { FlowId } from '../pages/flow/flow.cnst.js'

export const showHeaderShadow$ = new Subject<boolean>()

@Injectable({ providedIn: 'root' })
export class EventService {
  public onResume$ = new Subject<void>()
  public onPause$ = new Subject<void>()
  public leaveDemoMode$ = new Subject<void>()
  public graphClosed$ = new Subject<void>()
  public transitionDone$ = new Subject<void>()
  public modalClosed$ = new Subject<void>()
  public inAppBrowserClosed$ = new Subject<void>()
  public closeDrawer$ = new Subject<void>()
  public openInfoModal$ = new Subject<string>()
  public internalLinkClick$ = new Subject<string>()
  public appearanceUpdated$ = new Subject<string>()
  public onFlowDeactivation$ = new Subject<FlowId>()

  public quizOpened = signal<QuizId | undefined>(undefined)

  /**
   * A method awaiting user to come back to the app after leaving. To be called after user is expected to be out.
   * Will also wait for FaceID check to be passed.
   **/
  public async waitUntilActive(timeout = 60_000): Promise<boolean> {
    const isActive = pDefer<boolean>()

    const timeoutId = setTimeout(() => {
      isActive.resolve(false)
    }, timeout)

    void App.addListener('resume', () => {
      clearTimeout(timeoutId)
      isActive.resolve(true)
    })

    return await isActive
  }
}
